import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyCovH0pd2UBaD1TQSDmFQq8Q_3vnuHku_k",
  authDomain: "caribbean-traffic-tickets.firebaseapp.com",
  projectId: "caribbean-traffic-tickets",
  storageBucket: "caribbean-traffic-tickets.firebasestorage.app",
  messagingSenderId: "431746930952",
  appId: "1:431746930952:web:070373992829fc51e5f4bd",
  measurementId: "G-41M3Y4Y811"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

export default app;
